import React, { Component } from 'react'
import Basics from '../basics'
import List from '../list'
import NameLang from '../name-lang'

class ResumeComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  update = (field, data) => {
    this.props.update(field, data)
  }

  updateHeaders = (field, data) => {
    this.props.updateHeaders(field, data)
  }

  render() {
    return (
      <React.Fragment>
        <NameLang update={this.update} name={this.props.name} lang={this.props.lang} />

        <Basics
          update={this.update}
          model={this.props.basics}
          updateHeaders={this.updateHeaders}
          summaryHeader={this.props.headers.summary}
        />

        <hr class="separator" />

        <List
          modelName="education"
          label="If relevant, include your most recent educational achievements and the dates here."
          header={this.props.headers.education}
          update={this.update}
          updateHeaders={this.updateHeaders}
          items={this.props.education}
        />

        <hr className="separator" />

        <List
          modelName="work"
          label="Include your last 10 years of relevant experience and dates in this section. List your most recent position first."
          header={this.props.headers.work}
          update={this.update}
          updateHeaders={this.updateHeaders}
          items={this.props.work}
        />

        <hr className="separator" />

        <List
          modelName="link"
          label="You can add link to your portfolio, LinkedIn profile or personal website."
          header={this.props.headers.link}
          update={this.update}
          updateHeaders={this.updateHeaders}
          items={this.props.link}
        />

        <hr className="separator" />

        <List
          modelName="language"
          header={this.props.headers.language}
          update={this.update}
          updateHeaders={this.updateHeaders}
          items={this.props.language}
        />

        <hr className="separator" />

        <List
          modelName="skill"
          header={this.props.headers.skill}
          update={this.update}
          items={this.props.skill}
          updateHeaders={this.updateHeaders}
          showExperience={this.props.showExperience}
        />

        <hr className="separator" />

        <List
          modelName="course"
          header={this.props.headers.course}
          update={this.update}
          updateHeaders={this.updateHeaders}
          items={this.props.course}
        />

        <hr className="separator" />

        <List
          modelName="project"
          header={this.props.headers.project}
          update={this.update}
          updateHeaders={this.updateHeaders}
          items={this.props.project}
        />
      </React.Fragment>
    )
  }
}

export default ResumeComponent
